// reducers
import { TOGGLE_LOADING, GET_LOGIN_CONTENT } from "../../constants/AssetLibActionTypes";

const initialState = {
  loading: false,
  loginContent: [],
};

const loginReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return { ...state, loading: payload };
    case GET_LOGIN_CONTENT:
      return { ...state, loginContent: payload };
    default:
      return state;
  }
};
export default loginReducer;
